import { cssColorValue, spacer8 } from '@spotify-internal/encore-web';
import { checkboxStyle } from 'client/components/FieldCheckbox';
import styled from 'styled-components';

const grayLineColor = `#dedfe0`;
const disabledIconColor = `#c9cbcd`;
const enabledIconColor = `#292F36`;
const fontFamily = "'Maax', sans-serif";

export const Root = styled.div`
  .DraftEditor-root {
    position: relative;
  }

  & > div {
    border-width: 0;
    font-family: ${fontFamily};
    background: none;
    > div:first-of-type {
      display: flex;
      align-items: center;
      height: 58px;
      margin-right: 0;
      margin-left: 0;
      padding: 0 14px;
      border-bottom: 1px solid ${cssColorValue('essentialSubdued')};
      > div {
        margin-bottom: 0;
      }
      input {
        color: #292f36;
        font-size: 14px;
        font-family: ${fontFamily};
      }
    }
    > div:last-child {
      & > div > div > div {
        padding: 16px;
        font-weight: normal;
        line-height: 1.375rem;
        a:hover {
          text-decoration: none;
        }
      }
    }
    li,
    span {
      color: #292f36;
      font-size: 16px;
    }
    a li,
    a span {
      color: #5000b9 !important;
    }

    // Toolbar buttons
    > div > div > div {
      &:first-child > button {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }

      &:last-child > button {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }

      > button {
        border-color: ${grayLineColor};
        background-image: none;

        &:disabled {
          background-color: ${cssColorValue('backgroundHighlight')};
        }

        &:hover,
        &:focus {
          &:not(:disabled) {
            outline: solid 1px ${cssColorValue('essentialBase')};
            outline-offset: -1px;
          }
        }

        span {
          color: ${enabledIconColor};
        }
        &:disabled > span {
          color: ${disabledIconColor};
        }
      }

      // Link popover
      > button ~ div {
        width: fit-content;
        padding: ${spacer8};
        border-radius: 4px; 

        // '✘' and '✓' buttons
        button {
          &:hover,
          &:focus {
            outline: solid 1px ${cssColorValue('essentialBase')};
            outline-offset: -1px;
          }
        }

        label {
          display: flex;
          align-items: center;
          font-weight: normal;
          font-family: ${fontFamily};

          > ${checkboxStyle}
        }
      }
    }
  }
`;
